import {BackgroundBaseSettings, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalPagesBackgroundBaseSettings} from "./PortalPagesBackgroundBaseSettings";

export class PortalBackgroundBaseSettings extends BackgroundBaseSettings implements Parameter {
	constructor(data: any) {
		super(data);

		this.pages = PortalPagesBackgroundBaseSettings.fromJson(data?.pages);
	}

	public static fromJson(data: any): PortalBackgroundBaseSettings {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalBackgroundBaseSettings(data);
	}

	public clone(): PortalBackgroundBaseSettings {
		return PortalBackgroundBaseSettings.fromJson(this.toJson());
	}
}